export function formatMoney(value, { empty = '—', showPositiveSign = false } = {}) {
  const amount = Number(value);

  if (!Number.isFinite(amount)) return empty;

  const sign = amount < 0 ? '-' : showPositiveSign && amount > 0 ? '+' : '';
  const [integerPart, decimalPart] = Math.abs(amount).toFixed(2).split('.');
  const groupedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return `${sign}$${groupedInteger}.${decimalPart}`;
}

export function calculatePayrollSubtotal(employee = {}) {
  const mode = employee.salaryMode;

  if (mode === 'MENSUAL') {
    return Number(employee.baseSalary || 0);
  }

  const workedHours = Number(employee.workedMinutes || 0) / 60;
  const hourlyRate = Number(employee.hourlyRate || 0);

  return workedHours * hourlyRate;
}
